import { ChoiceOptionModel } from '@klant/conversational-connector/models/ChatMessage.model';

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
    selector: 'message-choice-option',
    templateUrl: './message-choice-option.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageChoiceOptionComponent {
    public readonly choiceOption = input.required<ChoiceOptionModel>();

    public readonly choiceOptionSelected = output<ChoiceOptionModel>();

    public onSelectOption(): void {
        this.choiceOptionSelected.emit(this.choiceOption());
    }
}
